// src/pages/IO/IO.tsx

import {
  AssignmentTwoTone,
  ImportExportTwoTone,
  PushPinTwoTone,
  SourceTwoTone,
} from '@mui/icons-material'
import {
  Avatar,
  Breadcrumbs,
  Card,
  CardContent,
  Typography,
} from '@mui/material'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { HStack, KPage } from '../../components'
import { OperatorData, useOperator } from '../../hooks'

const defaultSx = theme => ({
  width: 300,
  border: '1px solid',
  borderColor: 'divider',
  cursor: 'pointer',
  transition: theme.transitions.create(['background-color', 'box-shadow'], {
    duration: theme.transitions.duration.shortest,
  }),
  '&:hover': { bgcolor: 'action.hover' },
})

type IoCardProps = {
  title: string
  subtitle: string
  icon: ReactNode
  sx?: any
  onClick?: () => void
  disabled?: boolean
}

const IoCard = ({ title, subtitle, icon, ...rest }: IoCardProps) => {
  const { sx, ...cardProps } = rest

  return (
    <Card sx={[defaultSx, sx]} {...cardProps}>
      <CardContent>
        {icon}
        <Typography variant={'h6'}>{title}</Typography>
        <Typography>{subtitle}</Typography>
      </CardContent>
    </Card>
  )
}

export const IO = () => {
  const navigate = useNavigate()
  const opData: OperatorData = useOperator()

  return (
    <KPage
      avatar={
        <Avatar>
          <ImportExportTwoTone />
        </Avatar>
      }
      title={
        <Breadcrumbs sx={{ mx: 1, my: 2 }}>
          <Typography>Exporte</Typography>
        </Breadcrumbs>
      }
    >
      <HStack sx={{ width: 1, justifyContent: 'center' }} gap={1}>
        <IoCard
          icon={<AssignmentTwoTone fontSize={'large'} color={'primary'} />}
          onClick={() => navigate('/io/export-pdf')}
          subtitle={'PDF Export'}
          title={'Gebäude Berichte'}
        />

        <IoCard
          icon={<PushPinTwoTone fontSize={'large'} color={'primary'} />}
          onClick={() => navigate('/io/export-xls')}
          subtitle={'Excel Export'}
          title={'Zähler Informationen'}
        />

        {opData?.isAdmin && (
          <IoCard
            disabled={!opData?.isAdmin}
            icon={<SourceTwoTone fontSize={'large'} color={'primary'} />}
            onClick={() => navigate('/io/import-sensordata')}
            subtitle={'Daten Import'}
            title={'Messdaten aktualisieren'}
          />
        )}
      </HStack>
    </KPage>
  )
}
